// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"10758f18","361":"e92d8cea","423":"6de0c9d7","513":"0ad9a53d","542":"25c0468b","623":"067f447f","787":"4ada8902","854":"6d2419a3","951":"9450e7a3"}[chunkId] + ".chunk.js";
};